import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// @ts-nocheck
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

/**
 * Modal for managing (adding OR removing) a user's points. Opened from the
 * user-profile Controls dropdown. Two explicit buttons keep the intent clear:
 *   - "Adicionar" credits balance + lifetime
 *   - "Remover" debits balance only (lifetime is preserved)
 * Both hit the existing `/api/point-system/award` endpoint, which interprets
 * sign of the amount and enforces `pointSystem.manage` server-side.
 */
export default class AwardPointsModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "amount", 0);
    _defineProperty(this, "reason", '');
    // Track which button is mid-request so only it spins, not both.
    _defineProperty(this, "busy", null);
  }
  className() {
    return 'AwardPointsModal Modal--small';
  }
  title() {
    return app.translator.trans('ramon-point-system.forum.award_modal.title', {
      name: this.attrs.user.displayName()
    });
  }
  content() {
    var _this$attrs$user$attr, _this$attrs$user$attr2;
    const t = k => app.translator.trans('ramon-point-system.forum.award_modal.' + k);
    const balance = Number((_this$attrs$user$attr = this.attrs.user.attribute('pointBalance')) != null ? _this$attrs$user$attr : 0);
    const lifetime = Number((_this$attrs$user$attr2 = this.attrs.user.attribute('pointLifetime')) != null ? _this$attrs$user$attr2 : 0);
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "AwardPointsModal-current"
    }, m("span", null, t('current_balance'), ": ", m("strong", null, balance.toLocaleString())), m("span", null, t('current_lifetime'), ": ", m("strong", null, lifetime.toLocaleString()))), m("div", {
      className: "Form-group"
    }, m("label", null, t('amount_label')), m("input", {
      type: "number",
      className: "FormControl",
      min: "1",
      step: "1",
      value: this.amount,
      oninput: e => this.amount = Math.max(0, Number(e.target.value)),
      autofocus: true
    }), m("p", {
      className: "helpText"
    }, t('amount_help'))), m("div", {
      className: "Form-group"
    }, m("label", null, t('reason_label')), m("input", {
      type: "text",
      className: "FormControl",
      value: this.reason,
      oninput: e => this.reason = e.target.value,
      placeholder: t('reason_placeholder')
    })), m("div", {
      className: "Form-group AwardPointsModal-actions"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.busy === 'add',
      disabled: !this.amount || this.busy !== null,
      onclick: () => this.submit('add')
    }, m("i", {
      className: "fas fa-plus"
    }), " ", t('add')), m(Button, {
      className: "Button Button--danger",
      loading: this.busy === 'remove',
      disabled: !this.amount || this.busy !== null,
      onclick: () => this.submit('remove')
    }, m("i", {
      className: "fas fa-minus"
    }), " ", t('remove'))));
  }
  async submit(direction) {
    if (!this.amount) return;
    this.busy = direction;
    m.redraw();
    const signed = direction === 'add' ? Number(this.amount) : -Number(this.amount);
    try {
      const apiUrl = (app.forum.attribute('apiUrl') || '/api').replace(/\/+$/, '');
      const res = await app.request({
        method: 'POST',
        url: "".concat(apiUrl, "/point-system/award"),
        body: {
          userId: Number(this.attrs.user.id()),
          amount: signed,
          reason: this.reason || 'admin.adjustment'
        }
      });
      const data = (res == null ? void 0 : res.data) || res;
      if ((data == null ? void 0 : data.balance) !== undefined) {
        this.attrs.user.pushAttributes({
          pointBalance: Number(data.balance),
          pointLifetime: Number(data.lifetime)
        });
      }
      app.alerts.show({
        type: 'success'
      }, app.translator.trans(direction === 'add' ? 'ramon-point-system.forum.award_modal.added' : 'ramon-point-system.forum.award_modal.removed', {
        name: this.attrs.user.displayName(),
        amount: Number(this.amount).toLocaleString()
      }));
      this.hide();
    } catch (e) {
      var _e$response;
      app.alerts.show({
        type: 'error'
      }, (e == null || (_e$response = e.response) == null || (_e$response = _e$response.errors) == null || (_e$response = _e$response[0]) == null ? void 0 : _e$response.detail) || 'Failed');
    } finally {
      this.busy = null;
      m.redraw();
    }
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/AwardPointsModal', AwardPointsModal);